// extracted by mini-css-extract-plugin
export default {"deactivatedUser":"userTable_deactivatedUser__b9DIR"};